"use strict";exports.name="@sainsburys-tech/icons",exports.version="2.12.2";
